import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class AzzProductPreorderMessage extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updatePreorderMessage);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updatePreorderMessage);
  }

  /**
   * Updates the pre-order ship date message for the selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePreorderMessage = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPreorderMessage = event.detail.data.html.querySelector('azz-product-preorder-message');

    if (!newPreorderMessage) return;

    if (newPreorderMessage.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }

    morph(this, newPreorderMessage, { childrenOnly: true });
  };
}

if (!customElements.get('azz-product-preorder-message')) {
  customElements.define('azz-product-preorder-message', AzzProductPreorderMessage);
}
